import { colors } from "./colors";

export const paymentMethods: { id: string; name: string; color: string; icon: string; }[] = [
  {
    id: 'bank',
    name: 'bank',
    color: colors[0],
    icon: 'pi pi-building-columns',
  },
  {
    id: 'bizum',
    name: 'bizum',
    color: colors[3],
    icon: 'pi pi-mobile',
  },
  {
    id: 'cash',
    name: 'cash',
    color: colors[6],
    icon: 'pi pi-dollar',
  },
  {
    id: 'creditcard',
    name: 'creditcard',
    color: colors[11],
    icon: 'pi pi-credit-card',
  },
];